import { KWELLO_ICON, KwelloSvgIcon } from 'common/components/icon/KwelloSvgIcon';
import './SideNavHeader.scss';
import { useResize } from 'common/hooks/resize';

function SideNavHeader() {
  const { isTabletOrMobile } = useResize();

  return (
    <div className={`side-nav-header ${isTabletOrMobile ? 'tablet' : ''}`}>
      <KwelloSvgIcon
        icon={KWELLO_ICON.KWELLO_LOGO_ICON_ONLY}
        className={`kwello-logo-icon-small`}
      />

      <KwelloSvgIcon
        icon={KWELLO_ICON.KWELLO_LOGO}
        className={`kwello-logo-icon ${isTabletOrMobile ? 'tablet' : ''}`}
      />
    </div>
  );
}

export default SideNavHeader;
